module.exports = "/images/vendor/flag-icon-css/flags/1x1/mc.svg?78528abed80a64294f9a7141e62a394f";